import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import {MotifIcon} from '@ey-xd/motif-react';
import {IconoirXmark} from '@ey-xd/motif-icon';

const DrawerWrapper = (props) => {
	const {onClose, isOpen, showXButton = true, children, headerComponent, footerComponent} = props;

	function renderHeader() {
		return (
			<section className="header">
				<section className="opennew">{headerComponent()}</section>
				{showXButton && (
					<span className="copylabel" onClick={onClose}>
						<MotifIcon src={IconoirXmark} size="24" title={labels.closeLabel} />
					</span>
				)}
			</section>
		);
	}

	function renderBody() {
		return <section className="review-notes-detail-section">{children}</section>;
	}

	function renderFooter() {
		return <section className="footer_button">{footerComponent()}</section>;
	}

	return (
		<StyledSlider className="StyledSlider">
			<section className="slide-in">
				<StyledReviewNotesDrawer className={`${isOpen ? 'open-review-note-drawer' : ''}`}>
					{renderHeader()}
					{renderBody()}
					{renderFooter()}
				</StyledReviewNotesDrawer>
			</section>
		</StyledSlider>
	);
};

export default DrawerWrapper;

const StyledSlider = styled.section`
	.slide-in {
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		padding: var(--px-50);
		background: var(--modal-overlay--bg-color);
		z-index: 1000;
		@keyframes slideIn {
			from {
				transform: translateX(100%);
			}
			to {
				transform: translateX(0);
			}
		}
	}
`;

const StyledReviewNotesDrawer = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 60%;
	z-index: 2;
	position: absolute;
	top: var(--px-84);
	right: -200px;
	overflow: hidden;
	margin-bottom: var(--px-14);
	margin-right: 0.3rem;
	&.open-review-note-drawer {
		right: 0 !important;
		position: absolute;
		bottom: -1rem;
		top: auto;
		height: 100vh;
		background: var(--neutrals-bg-gradient1);
		box-shadow: -8px 0px 15px 0px rgba(46, 46, 56, 0.15);
	}
	.header {
		display: flex;
		padding: var(--px-24) var(--px-32) var(--px-0) var(--px-32);
		z-index: 3;
		font-size: var(--px-24);
		color: var(--neutrals-900);
		margin-bottom: var(--px-16);
		& > * {
			font-size: var(--px-14);
			font-weight: bold;
			color: var(--blue-600);
		}
		.opennew {
			margin-right: auto;
			font-weight: 400;
			a {
				margin-right: 2rem;
				color: var(--blue-600);
			}
			svg {
				max-width: 1.8rem;
				margin: 0 0.5rem 0 0;
				vertical-align: middle;
				fill: var(--blue-600);
			}
		}
		.copylabel {
			cursor: pointer;
			vertical-align: middle;
		}
		.closemodal {
			svg {
				max-width: 1.8rem;
				margin: 0 0 0 0.5rem;
				vertical-align: middle;
				fill: var(--blue-600);
			}
			.closelabel {
				cursor: pointer;
				vertical-align: top;
			}
		}
		a {
			margin-right: auto;
			font-weight: bold;
			vertical-align: middle;
		}
		p {
			font-size: 1.2rem;
			font-weight: bold;
			margin-top: 1rem;
		}
	}
	.review-notes-detail-section {
		flex: 1;
		display: flex;
		flex-direction: column;
		.no-note-selected {
			display: none;
		}
	}
	.footer_button {
		position: absolute;
		width: 100%;
		bottom: 0;
		z-index: 3;
		display: flex;
		padding: var(--px-24) var(--px-32);
		justify-content: flex-end;
		button {
			margin-right: var(--px-12);
		}
	}
`;
